import React, { useState, useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'srcReact/components/common2/Button'
import { TextBox } from 'srcReact/components/common2/TextBox'
import { isEmpty } from 'srcReact/helpers/validator'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Spinner from 'srcReact/components/common2/Spinner'
import { decode } from 'html-entities/lib/index'
import { createUpdateGroupActions } from 'srcReact/GroupPage'

export default function GroupName({
  show,
  hideNextButton,
  nextSectionVisible,
  action,
  containerCss,
  verticalLineCss,
  infoCss,
  innerContainerCss,
  titleCss,
  buttonWrapperCss,
  editMode = false
}) {
  const containerRef = useRef(null)
  const { t } = useTranslation()
  useEffect(() => {
    if (!isGeneralGroup && !editMode) {
      containerRef.current.scrollIntoView(true, { behavior: 'smooth' })
    }
  }, [show])

  const dispatch = useDispatch()
  const {
    createUpdateGroup: { groupName: globalGroupName, groupInfo, isGeneralGroup, loading, editSuccess },
    common: { isMobile },
    login: { user }
  } = useSelector((state) => state)

  const [focusedMode, setFocusedMode] = useState(false)

  const [groupName, setGroupName] = useState({
    name: 'groupName',
    value:
      globalGroupName && globalGroupName.value.length > 0
        ? globalGroupName.value
        : groupInfo && groupInfo.info
        ? groupInfo.info.name
        : '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  useEffect(() => {
    setGroupName({ ...groupName, value: '', hasError: false, errorMessage: '' })
  }, [])

  const [infoForEditReceived, setInfoForEditReceived] = useState(false)
  useEffect(() => {
    if (editMode && groupInfo && !infoForEditReceived) {
      setInfoForEditReceived(true)
      setGroupName({
        name: 'groupName',
        value: groupInfo ? decode(groupInfo.name) : '',
        hasError: false,
        errorMessage: '',
        isRequired: true
      })
    }
  }, [editMode, groupInfo])

  useEffect(() => {
    if (editMode && editSuccess && focusedMode) {
      setFocusedMode(false)
      dispatch(createUpdateGroupActions.setGroupName(groupName))
    }
  }, [editSuccess])

  const handleChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target
      setGroupName({
        ...groupName,
        value: value
      })
    }
  }
  const handleBlur = (e) => {
    // if (!editMode) {
    //   validate()
    // }
  }

  const handleFocus = (e) => {
    setFocusedMode(true)
  }

  const handleNext = () => {
    if (validate()) {
      dispatch(createUpdateGroupActions.setGroupName(groupName))
      dispatch(createUpdateGroupActions.showPictureUpload())
    }
  }
  const handleSave = () => {
    if (validate()) {
      dispatch(createUpdateGroupActions.editGroup(groupInfo.id, { name: groupName.value }))
    }
  }

  const handleCancel = () => {
    setFocusedMode(false)
    setGroupName({
      name: 'groupName',
      value: globalGroupName.value,
      hasError: false,
      errorMessage: '',
      isRequired: true
    })
  }

  function validate() {
    if (groupName.isRequired && isEmpty(groupName.value)) {
      setGroupName({
        ...groupName,
        hasError: true,
        errorMessage: t('error.required', { field: t(`formlabel.${groupName.name}`) })
      })
      return false
    }
    if (groupName.value.length > 60) {
      setGroupName({
        ...groupName,
        hasError: true,
        errorMessage: t('error.textLengthExceed', { length: 60 })
      })
      return false
    }
    setGroupName({
      ...groupName,
      hasError: false,
      errorMessage: ''
    })
    return true
  }
  const jumpToNextAfterUpdate = () => {
    if (validate()) {
      const nextContainer = document.querySelector('#imageUploadContainer')
      nextContainer.scrollIntoView(true, { behavior: 'smooth' })
      dispatch(createUpdateGroupActions.setGroupName(groupName))
    }
  }
  useEffect(() => {
    if (!editMode) {
      dispatch(createUpdateGroupActions.setGroupName(groupName))
    }
  }, [groupName])

  return (
    <div
      ref={containerRef}
      className={`${containerCss}   ${!nextSectionVisible && !editMode && styles.container}  ${
        show || (globalGroupName && globalGroupName.value) ? styles.show : styles.hide
      }`}>
      {!editMode && <div class={`${verticalLineCss} ${styles.verticalLine}`} />}
      {!editMode ? (
        isGeneralGroup ? (
          <p className={`${infoCss} ${styles.innerPara}`}>{t('group.createGeneralGroup.groupName.title1')}</p>
        ) : (
          <p className={infoCss}>{t('group.createGroup.groupName.title1')}</p>
        )
      ) : null}
      <div className={innerContainerCss}>
        <TextBox
          label={
            editMode
              ? t('group.editGroup.groupNameTitle')
              : isGeneralGroup
              ? t('group.createGeneralGroup.groupName.title2')
              : t('group.createGroup.groupName.title2')
          }
          title={t('group.createGroup.groupName.charLimit', { charLimit: 60 })}
          name='groupName'
          isRequired={true}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          placeholder={t('group.createGroup.groupName.placeholder')}
          fieldInfo={groupName}
          customWrapperCss={styles.inputWrapper}
          customLabelCss={titleCss}
          maxLength={60}
        />
        <div className={buttonWrapperCss}>
          {editMode ? (
            focusedMode || groupName.hasError ? (
              <React.Fragment>
                <Button style='tertiary' type='button' handleClick={handleCancel} text={t('global.cancel')} />
                <Button
                  type='button'
                  handleClick={handleSave}
                  text={loading ? <Spinner isWhite={true} /> : t('global.save')}
                />
              </React.Fragment>
            ) : null
          ) : !hideNextButton ? (
            <Button
              type='button'
              disabled={groupName && groupName.value.length === 0}
              handleClick={nextSectionVisible ? jumpToNextAfterUpdate : handleNext}
              text={nextSectionVisible ? t('group.createGroup.btnNext') : t('group.createGroup.btnNext')}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}
